import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router'

export const menuFixerAgentRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/MenuFixerAgentView.vue'),
    name: 'menuFixerAgent',
    path: 'menu-fixer/:menuId',
    props: (route: RouteLocationNormalized) => ({
      menuId: route.params.menuId,
    }),
  },
]
